export enum CalendarMode {
  dayGridDay = 'dayGridDay',
  timeGridDay = 'timeGridDay',
  timeGridWeek = 'timeGridWeek',
  dayGridMonth = 'dayGridMonth'
}
